export const saveSection = [
  '',
  `mutation saveContentSlider($input: SliderInput018!) {
    saveContentSlider(section:$input) {
        id
      }
    }`,
  'saveContentSlider',
];
